import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("nm_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);

const FS = { small: 0.9, normal: 1, large: 1.15 };

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("nm_lang") || "mr");
  const [fontSize, setFontSize] = useState(() => localStorage.getItem("nm_fs") || "normal");
  const [token, setToken] = useState(() => localStorage.getItem("nm_token"));

  useEffect(() => {
    localStorage.setItem("nm_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("nm_fs", fontSize);
    document.documentElement.style.setProperty("--fs-scale", FS[fontSize]);
  }, [fontSize]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("nm_token", data.token);
    setToken(data.token);
    return data;
  };
  const logout = () => { localStorage.removeItem("nm_token"); setToken(null); };

  const t = (obj, key) => (obj ? (obj[`${key}_${lang}`] ?? obj[`${key}_en`] ?? "") : "");
  const L = (o) => (o ? (o[lang] ?? o.en) : "");

  return (
    <AppCtx.Provider value={{ lang, setLang, fontSize, setFontSize, token, login, logout, isAuthed: !!token, t, L }}>
      {children}
    </AppCtx.Provider>
  );
}
